import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import HomepageBanner from '../components/HomepageBanner';
import Footer from '../components/Footer';
import { ServiceCard } from '../components/ServiceCard';

class Homepage extends Component {
  state = { services: null, openFaq: 0 };

  componentDidMount() {
    window.scrollTo(0, 0);
    const { services } = this.props.services;
    const printers = services.filter(
      (s) => s.cover && s.cover.startsWith('/printers/'),
    );
    this.setState({ services: printers });
  }

  toggleFaq = (index) => {
    this.setState((prev) => ({
      openFaq: prev.openFaq === index ? -1 : index,
    }));
  };

  render() {
    const categories = [
      {
        title: 'Home Printers',
        desc: 'Ideal picks for everyday home printing.',
      },
      {
        title: 'Office Printers',
        desc: 'Built to handle busy workloads.',
      },
      {
        title: 'Inkjet Printers',
        desc: 'Vibrant color and photo printing.',
      },
      {
        title: 'Laser Printers',
        desc: 'Speed and efficiency at a great value.',
      },
    ];

    const faqs = [
      {
        question: 'Are all printers on your store genuine?',
        answer:
          'Every product we carry comes directly from authorized distributors and reputable manufacturers. We never stock refurbished or counterfeit items.',
      },
      {
        question: 'How can I pick the best printer for my situation?',
        answer:
          'Think about how much you print, whether you need color or black-and-white, and any extras like scanning or faxing. Our detailed product pages and tags make side-by-side comparison easy.',
      },
      {
        question: 'Do you show all costs upfront?',
        answer:
          'Yes — every listing includes the full price, specs, and features with no hidden charges. What you see is exactly what you pay at checkout.',
      },
      {
        question: 'How safe is your payment process?',
        answer:
          'We protect every transaction with SSL encryption and trusted payment providers, so your personal and financial data stays secure.',
      },
    ];

    const testimonials = [
      {
        text: '"Found the perfect home printer in minutes. Clear specs, easy checkout, and it arrived right on time."',
        name: 'Alex Smith',
        role: 'Home User',
      },
      {
        text: '"Great variety and honest pricing. The product details made it simple to pick the right laser printer for our office."',
        name: 'John D.',
        role: 'Small Business Owner',
      },
      {
        text: '"The whole experience was hassle-free — browsing, ordering, and delivery. Printer works exactly as described."',
        name: 'Patricia S.',
        role: 'Office Administrator',
      },
    ];

    if (this.state.services) {
      return (
        <div>
          <HomepageBanner />

          {/* Categories Section */}
          <section className='categories-section'>
            <div className='container'>
              <h2 className='section-title'>Browse by Category</h2>
              <p className='section-subtitle'>
                Find the perfect printer for any need — every category features
                genuine products backed by a full warranty.
              </p>
              <div className='categories-grid'>
                {categories.map((cat, i) => (
                  <div className='category-card' key={i}>
                    <h4 className='category-card__title'>{cat.title}</h4>
                    <p className='category-card__desc'>{cat.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Featured Printers */}
          <section className='featured-section'>
            <div className='container'>
              <h2 className='section-title'>Our Top Picks</h2>
              <p className='section-subtitle'>
                Hand-picked printers trusted by thousands of home and office
                users.
              </p>
              <div className='products-grid'>
                {this.state.services.map((service, index) => (
                  <ServiceCard service={service} index={index} key={index} />
                ))}
              </div>
            </div>
          </section>

          {/* About Section */}
          <section className='about-section'>
            <div className='container'>
              <p className='about-section__label'>WHO WE ARE</p>
              <h2 className='about-section__title'>
                Your Go-To Destination for Trusted Printers
              </h2>
              <div className='about-section__content'>
                <p>
                  We specialize in printers and printing solutions for homes,
                  small businesses, and corporate offices. Our mission is to
                  make buying a printer straightforward, honest, and
                  hassle-free.
                </p>
                <p>
                  Every model on our site is hand-picked for performance,
                  reliability, and real-world value. From inkjet to laser,
                  all-in-one to wireless — we only carry genuine products with
                  transparent pricing.
                </p>
                <p>
                  Enjoy secure payments, responsive support, and quick order
                  processing from the moment you browse to the day your printer
                  arrives. Whatever your printing needs, we have the right
                  machine for you.
                </p>
              </div>
              <Link to='/about-us' className='about-section__btn'>
                Learn More About Us
              </Link>
            </div>
          </section>

          {/* FAQ Section */}
          <section className='faq-section'>
            <div className='container'>
              <h2 className='section-title'>Why Shop With Us</h2>
              <p className='section-subtitle'>
                Quality products, clear pricing, and a customer-first approach
                at every step.
              </p>
              <div className='faq-layout'>
                <div className='faq-image'>
                  <img
                    src='/images/why-choose-printers.jpg'
                    alt='Printer'
                    onError={(e) => {
                      e.target.parentElement.style.background = '#f0f4ff';
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
                <div className='faq-accordion'>
                  {faqs.map((faq, i) => (
                    <div
                      className={`faq-item ${this.state.openFaq === i ? 'faq-item--open' : ''}`}
                      key={i}
                    >
                      <button
                        className='faq-item__question'
                        onClick={() => this.toggleFaq(i)}
                      >
                        <span>{faq.question}</span>
                        <span className='faq-item__icon'>
                          {this.state.openFaq === i ? '−' : '+'}
                        </span>
                      </button>
                      {this.state.openFaq === i && (
                        <div className='faq-item__answer'>
                          <p>{faq.answer}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Testimonials */}
          <section className='testimonials-section'>
            <div className='container'>
              <h2 className='section-title'>Customer Reviews</h2>
              <p className='section-subtitle'>
                Real feedback from buyers who found the right printer through
                our store.
              </p>
              <div className='testimonials-grid'>
                {testimonials.map((t, i) => (
                  <div className='testimonial-card' key={i}>
                    <p className='testimonial-card__text'>{t.text}</p>
                    <div className='testimonial-card__author'>
                      <strong>{t.name}</strong>
                      <span>{t.role}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <Footer />
        </div>
      );
    } else {
      return (
        <div>
          <h3> LOADING.. </h3>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  services: state.services,
});

export default connect(mapStateToProps, {})(Homepage);
